export default __webpack_public_path__ + "static/media/layout02.37eb12cf.png";